import { MessageCircle } from "lucide-react";

/**
 * Floating WhatsApp button — bottom right, permanent on public pages.
 */
export default function WhatsAppFAB({ message = "Olá! Gostaria de pedir um orçamento." }) {
    const url = `https://wa.me/351967318921?text=${encodeURIComponent(message)}`;
    return (
        <a
            href={url}
            target="_blank"
            rel="noreferrer"
            aria-label="Contactar por WhatsApp"
            data-testid="whatsapp-fab"
            className="ab-wa-fab no-print"
        >
            <span className="ab-wa-fab-pulse" aria-hidden="true" />
            <MessageCircle className="w-6 h-6 relative z-10" strokeWidth={2.2} />
            <span className="ab-wa-fab-label">WhatsApp</span>
        </a>
    );
}
